module.exports = __webpack_public_path__ + "img/icon-parking-lot.9f7d3d68.png";